<template>
  <div v-if="!isDestroy"
       v-show="visible"
       style="position: absolute;overflow: hidden;left: 0;right: 0;">
    <canvas v-show="canvasData && canvasData.data.length"
            id="canvas"
            :width="width"
            :height="height"></canvas>
    <div v-if="canvasData"
         @click.stop.prevent
         @pointerdown.stop.prevent
         @touchstart.stop.prevent>

      <div class="lable-config-panel">
        <layout-panel :collapse="false">
          <span slot="header">工具栏</span>
          <div style="margin-bottom: 10px;">
            图像识别ID:{{data.image_id}}
          </div>
          <div style="margin-bottom: 10px;">
            <el-button type="primary"
                       size="mini"
                       :disabled="!!this.data.is_exception"
                       :loading="feedbackExceptionloading"
                       @click="onFeedbackException">
              <template v-if="this.data.is_exception">已反馈识别异常</template>
              <template v-else>识别异常反馈</template>
            </el-button>
          </div>
          <!--<el-select-->
          <!--v-model="selectedProduct"-->
          <!--filterable-->
          <!--clearable-->
          <!--size="mini"-->
          <!--value-key="number"-->
          <!--@change="onProductNumberChange"-->
          <!--placeholder="请选择产品">-->
          <!--<el-option-->
          <!--v-for="product in products"-->
          <!--:key="product.number"-->
          <!--:label="product.name"-->
          <!--:value="product">-->
          <!--<span style="float: left;">{{ product.name }}</span>-->
          <!--<span style="float: right; color: #8492a6; font-size: 13px">{{ product.total }}</span>-->
          <!--</el-option>-->
          <!--</el-select>-->
          <ul class="lable-color-picker"
              style="margin-top: 15px;">
            <li>
              <el-color-picker
                v-model="color.default.stroke"
                show-alpha
                size="mini"
                :predefine="predefineColors"
                @change="onChangeColor">
              </el-color-picker>
              <p>默认</p>
            </li>
            <li>
              <el-color-picker
                v-model="color.hover.stroke"
                show-alpha
                size="mini"
                :predefine="predefineColors"
                @change="onChangeColor">
              </el-color-picker>
              <p>悬浮</p>
            </li>
            <li>
              <el-color-picker
                v-model="color.active.stroke"
                show-alpha
                size="mini"
                :predefine="predefineColors"
                @change="onChangeColor">
              </el-color-picker>
              <p>活跃</p>
            </li>
          </ul>
        </layout-panel>
      </div>

      <div
        :style="`position: absolute;top: ${top}px;left: ${left}px;width: ${canvasData.width}px; height: ${canvasData.height}px;transform: rotate(${angle}deg) scale(${scaleX},${scaleY});visibility: hidden;`">
        <el-popover
          placement="bottom"
          :title="selectedPathData.name"
          width="200"
          trigger="manual"
          v-model="popoverVisible">
          <div class="lable-selected-path-data">
            <p>标注ID：{{selectedPathData.id}}</p>
            <p>产品编号：{{selectedPathData.number}}</p>
          </div>
          <div slot="reference"
               ref="popover"
               style="position: absolute;"></div>
        </el-popover>
      </div>
    </div>
  </div>
</template>
<script>
import fabric from '@/vendor/fabric'
import { toLabelData } from './utils'

export default {
  components: {},
  data () {
    return {
      data: null,
      canvasData: null,
      canvas: null,
      visible: false,
      isDestroy: false,
      popoverVisible: false,
      // products: [],
      selectedProduct: null,
      left: 0,
      top: 0,
      matrix: [1, 0, 0, 1, 0, 0],
      width: 0,
      height: 0,
      color: {
        default: {
          fill: 'rgba(64, 158, 255, 0.05)',
          stroke: 'rgba(64, 158, 255)',
          strokeWidth: 1,
        },
        hover: {
          fill: 'rgba(255, 64, 64, 0.05)',
          stroke: 'rgba(255, 64, 64)',
          strokeWidth: 2,
        },
        active: {
          fill: 'rgba(64, 255, 64, 0.05)',
          stroke: 'rgba(64, 255, 64)',
          strokeWidth: 2,
        },
      },
      predefineColors: [
        'rgba(64, 158, 255)',
        'rgba(255, 64, 64)',
        'rgba(64, 255, 64)',
      ],
      angle: 0,
      scaleX: 1,
      scaleY: 1,
      selectedPathData: {
        id: '',
        name: '',
        number: '',
      },
      feedbackExceptionloading: false,
    }
  },
  computed: {},
  watch: {
    matrix () {
      let options = fabric.util.qrDecompose(this.matrix)
      this.angle = options.angle
      this.scaleX = options.scaleX
      this.scaleY = options.scaleY
    },
    visible (val) {
      if (!val) {
        this.popoverVisible = false
      }
    },
  },
  created () {},
  destroyed () {},
  methods: {
    init () {
      this.isDestroy = false
      let data = filter.copyJson(this.data)
      this.canvasData = toLabelData(data.labels, data.width, data.height)
      this.$nextTick(() => {
        // this.products = data.products.filter(o => o.total > 0)
        this.loadCanvas()
        this.loadGraphicsPath()
        this.canvas.renderAll()
      })
    },
    destroy () {
      this.isDestroy = true
    },
    update () {
      if (this.canvasData.data.length) {
        let canvas = this.canvas
        canvas.clear()
        this.loadGraphicsPath()
        canvas.renderAll()
      }
    },
    loadCanvas () {
      this.canvas = new fabric.Canvas('canvas', {
        selection: false,
        hoverCursor: 'auto',
        selectable: false,
        evented: false,
        // backgroundColor: 'beige'
      })
      // canvas.on('mouse:move', (e) => {
      //   // console.log('mouse:move')
      // })
      // canvas.on('mouse:down', (e) => {
      //   // console.log('mouse:down')
      // })
      // canvas.on('mouse:up', (e) => {
      // //   console.log('mouse:up')
      // })
      // canvas.on('mouse:over', (e) => {
      // })
      // canvas.on('mouse:out', (e) => {
      // })
    },
    loadGraphicsPath () {
      let canvas = this.canvas
      let canvasData = this.canvasData
      let region = new fabric.Rect({
        width: canvasData.width,
        height: canvasData.height,
        fill: 'transparent',
        stroke: 'transparent',
        hoverCursor: 'auto',
        selectable: false,
        evented: false,
      })
      canvas.add(region)
      canvasData.data.map((data, index) => {
        let path = new fabric.Path(data.SVGPath)
        path.set({
          fill: this.color.default.fill,
          stroke: this.color.default.stroke,
          strokeWidth: this.color.default.strokeWidth,
          hoverCursor: 'pointer',
          selectable: false,
          evented: true,
          data,
          index,
        })
        this.registerPathEvent(path)
        canvas.add(path)
        return path
      })
      this.showSelectProductPath()
      this.transform()
    },
    registerPathEvent (path) {
      let canvas = this.canvas
      path.on('mouseover', (e) => {
        // console.log('mouseover')
        if (this.visible && e.target) {
          let style = this.$refs.popover.style
          let target = e.target
          this.selectedPathData.id = e.target.data.id
          this.selectedPathData.name = e.target.data.product.name
          this.selectedPathData.number = e.target.data.product.number
          style.left = target.data.realPath[0] + 'px'
          style.top = target.data.realPath[1] + 'px'
          style.width = target.width + 2 + 'px'
          style.height = target.height + 2 + 'px'
          this.$nextTick(() => {
            this.popoverVisible = true
          })
          e.target.set('stroke', this.color.hover.stroke)
          e.target.set('strokeWidth', this.color.hover.strokeWidth)
          canvas.renderAll()
        }
      })
      path.on('mouseout', (e) => {
        if (this.visible && e.target) {
          this.popoverVisible = false
          e.target.set('stroke', this.color.default.stroke)
          e.target.set('strokeWidth', this.color.default.strokeWidth)
          canvas.renderAll()
        }
      })
    },
    makeActiveSelection () {
      let canvas = this.canvas
      let selection = new fabric.ActiveSelection(canvas.getObjects(), {
        canvas: canvas,
        hasControls: false,
        hasBorders: false,
      })
      canvas.setActiveObject(selection)
      return selection
    },
    transform () {
      let canvas = this.canvas
      let selection = this.makeActiveSelection()
      selection.left = this.left
      selection.top = this.top

      let currentT = selection.calcTransformMatrix()
      let mT = fabric.util.multiplyTransformMatrices(currentT, this.matrix)
      let options = fabric.util.qrDecompose(mT)

      selection.transformMatrix = [1, 0, 0, 1, 0, 0]
      selection.flipX = false
      selection.flipY = false
      selection.set(options)
      selection.setPositionByOrigin({x: options.translateX, y: options.translateY}, 'center', 'center')
      canvas.discardActiveObject()
    },
    showSelectProductPath () {
      let canvas = this.canvas
      let product = this.selectedProduct
      canvas.getObjects().forEach((path) => {
        if (path.type !== 'path') {
          return
        }
        if (product) {
          if (product.number === path.data.product.number) {
            path.set('visible', true)
            path.set('fill', this.color.active.fill)
            path.set('stroke', this.color.active.stroke)
            path.set('strokeWidth', this.color.active.strokeWidth)
          } else {
            path.set('visible', false)
          }
        } else {
          path.set('visible', true)
          path.set('fill', this.color.default.fill)
          path.set('stroke', this.color.default.stroke)
          path.set('strokeWidth', this.color.default.strokeWidth)
        }
      })
    },
    onProductNumberChange () {
      this.showSelectProductPath()
      this.canvas.renderAll()
    },
    onChangeColor () {
      if (this.selectedProduct) {
        this.onProductNumberChange(this.selectedProduct)
      } else {
        let canvas = this.canvas
        canvas.getObjects().forEach((path) => {
          path.set('fill', this.color.default.fill)
          path.set('stroke', this.color.default.stroke)
          path.set('strokeWidth', this.color.default.strokeWidth)
        })
        this.canvas.renderAll()
      }
    },
    onFeedbackException () {
      this.$confirm('确认反馈图片识别异常吗？', '提示', {type: 'warning'}).then(() => {
        this.feedbackExceptionloading = true
        request.common('feedbackImageRecognitionException', {id: this.data.image_id}).then(() => {
          this.data.is_exception = 1
        }).finally(() => {
          this.feedbackExceptionloading = false
        })
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.lable-config-panel {
  line-height: normal;
  font-size: 14px;
  position: absolute;
  right: 5px;
  top: 0;

  .panel {
    background-color: rgba(255, 255, 255, 0.95);
  }
}

.lable-color-picker {
  list-style: none;
  margin: 0px;
  padding: 0px;

  li {
    display: inline-block;
    padding-right: 15px;

    p {
      font-size: 12px;
      margin-top: 7px;
      margin-left: 2px;
      margin-bottom: 0;
    }
  }
}

.lable-selected-path-data {
  margin-top: -5px;

  p {
    font-size: 12px;
    margin-bottom: 0;
    margin-top: 5px;
    word-wrap: break-word;
    word-break: break-all;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/LableResult/src/main.vue